// Custom Page Visibility Handler
document.addEventListener("DOMContentLoaded", function() {
  // Fix for blank page issue when switching tabs
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') {
      // Check if page is blank and force redraw if needed
      if (!document.body.innerHTML.trim()) {
        document.body.style.display = 'none';
        setTimeout(() => document.body.style.display = '', 10);
      }

      // Reinitialize components
      initializeComponents();
    }
  });
});

function initializeComponents() {
  // Reinitialize bid timers
  if (typeof initBidTimers === 'function') {
    initBidTimers();
  }

  // Reinitialize secondary media carousels
  document.querySelectorAll('secondary-media:not(.flickity-enabled)').forEach(element => {
    if (element.template && element.template.content) {
      element.innerHTML = '';
      element.appendChild(element.template.content.cloneNode(true));
      const mediaCount = element.querySelectorAll('.media').length;

      if (mediaCount > 1) {
        new Flickity(element, {
          accessibility: false,
          draggable: false,
          pageDots: true,
          prevNextButtons: false,
          wrapAround: true,
          rightToLeft: false
        });

        if (mediaCount === 2) {
          element.classList.add('without-dots');
        }

        element.addEventListener('mousemove', function(event) {
          if (mediaCount === 2) {
            return element.flickity.select(1);
          }
          
          const width = element.flickity.size.width;
          const mouseX = event.clientX - element.getBoundingClientRect().left;
          
          if (mediaCount === 3) {
            if (mouseX < width / 2) {
              return element.flickity.select(1);
            }
            return element.flickity.select(2);
          }
          
          if (mediaCount === 4) {
            if (mouseX < width / 3) {
              return element.flickity.select(1);
            }
            if (mouseX < (2 * width) / 3) {
              return element.flickity.select(2);
            }
            return element.flickity.select(3);
          }
        });

        element.addEventListener('mouseleave', function() {
          element.flickity.select(0);
        });
      }
    }
  });
} 